import { createFileRoute } from '@tanstack/react-router';

import {
  dashboardRouteSearchSchema,
  parseDashboardRouteSearch,
} from '../features/dashboard/dashboardRouteSearch';
import { PublisherDashboardPage } from '../features/publisher/dashboard/PublisherDashboardPage';

export const Route = createFileRoute('/p/$publisherId')({
  validateSearch: dashboardRouteSearchSchema,
  component: PublisherDashboardRoute,
});

function PublisherDashboardRoute() {
  const { publisherId } = Route.useParams();
  parseDashboardRouteSearch(Route.useSearch());
  return <PublisherDashboardPage publisherId={publisherId} />;
}
